import { Link } from "react-router-dom";
import { Phone, Mail } from "lucide-react";

export const ContactCtaSection = ({ content }) => {
  return (
    <section className="py-20 bg-primary text-primary-foreground" data-testid="contact-cta-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="font-display text-3xl sm:text-4xl font-black uppercase tracking-tight mb-4">
          {content.heading}
        </h2>
        {content.description && (
          <p className="font-medium mb-8 max-w-xl mx-auto opacity-80">{content.description}</p>
        )}
        <div className="flex flex-wrap justify-center gap-4 mb-8">
          {content.primary_label && (
            <Link
              to={content.primary_url || "/inventory"}
              className="inline-flex items-center justify-center gap-2 bg-black text-primary font-bold uppercase tracking-wider text-sm px-7 py-3.5 hover:bg-zinc-900 transition-colors"
              style={{ borderRadius: "var(--btn-radius, 2px)" }}
              data-testid="contact-cta-primary"
            >
              {content.primary_label}
            </Link>
          )}
          {content.secondary_label && (
            <Link
              to={content.secondary_url || "/contact"}
              className="inline-flex items-center justify-center gap-2 border-2 border-black/70 font-bold uppercase tracking-wider text-sm px-7 py-3.5 hover:bg-black/10 transition-colors"
              style={{ borderRadius: "var(--btn-radius, 2px)" }}
              data-testid="contact-cta-secondary"
            >
              {content.secondary_label}
            </Link>
          )}
        </div>
        <div className="flex flex-wrap justify-center gap-8 text-sm font-medium">
          {content.phone && (
            <a href={`tel:${content.phone}`} className="inline-flex items-center gap-2 hover:underline" data-testid="contact-cta-phone">
              <Phone className="h-4 w-4" /> {content.phone}
            </a>
          )}
          {content.email && (
            <a href={`mailto:${content.email}`} className="inline-flex items-center gap-2 hover:underline" data-testid="contact-cta-email">
              <Mail className="h-4 w-4" /> {content.email}
            </a>
          )}
        </div>
      </div>
    </section>
  );
};
